import { render, staticRenderFns } from "./pubCert.vue?vue&type=template&id=71f69345"
import script from "./pubCert.vue?vue&type=script&lang=js"
export * from "./pubCert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports